import EventJsonld from '@/utils/mixins/EventJsonld'
export default {
  mixins: [EventJsonld],
  computed: {
    jsonDataLists() {
      return JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Event',
        eventAttendanceMode: this.isOnlineEvent ? 'https://schema.org/OnlineEventAttendanceMode' : 'https://schema.org/OfflineEventAttendanceMode',
        name: this.event.title,
        description: this.meta.description,
        url: import.meta.env.ROOT_URL + this.$route.fullPath,
        eventStatus: this.eventStatusType,
        startDate: this.event.start_at,
        endDate: this.event.end_at,
        image: this.event.eyecatch_image.url,
        organizer: {
          '@type': 'Organization',
          name: this.event.organizer_name,
          url: this.event.organizer_promoter_event_slug ? `${import.meta.env.ROOT_URL}/promoters/${this.event.organizer_promoter_event_slug}` : ''
        },
        location: this.locationData,
        offers: this.offersByTicketInfo(this.event, this.ticketInfo.tickets),
        performer: {
          '@type': 'PerformingGroup',
          name: this.event.organizer_name
        }
      })
    },
    locationData() {
      if (this.isOnlineEvent) {
        return {
          '@type': 'VirtualLocation',
          url: 'https://operaonline.stream5.com/'
        }
      } else {
        return {
          '@type': 'Place',
          name: this.event.place,
          address: this.addressData
        }
      }
    },
    addressData() {
      const parsedAddress = this.parseAddress(this.event.address_full)
      const addressRegion = this.event.prefecture_name
      const addressLocality = parsedAddress[0] || ''
      const streetAddress = parsedAddress[1] || ''
      return {
        '@type': 'PostalAddress',
        addressRegion,
        addressLocality,
        streetAddress
      }
    }
  },
  methods: {
    parseAddress(addressStr) {
      if (!addressStr) return []
      const regExpOfShikuchoson =
        /((?:旭川|伊達|石狩|盛岡|奥州|田村|南相馬|那須塩原|東村山|武蔵村山|羽村|十日町|上越|富山|野々市|大町|蒲郡|四日市|姫路|大和郡山|廿日市|下松|岩国|田川|大村)市|.+?郡.+?[町村]|.+?市.+?区|.+?[市区町村])(.+)/
      const parsedAddress = addressStr.replace(/^(...??[都道府県])/, '').match(regExpOfShikuchoson)
      if (!parsedAddress) return []
      return parsedAddress.slice(-2)
    },
    createJsonldToHead() {
      useHead({
        script: [{ children: this.$sanitizedXssHtml(this.jsonDataLists), type: 'application/ld+json' }]
      })
    }
  }
}
